import * as types from '../constants/ActionTypes'

export default function patient_records(state = {}, action) {
	switch (action.type) {

		case types.SET_PATIENT_RECORDS:
			return action.payload.reduce((obj, record) => {
				obj[record._id] = record;
				return obj
			}, {});

		case types.INSERT_PATIENT_RECORD:
			return {...state, [action.payload._id]: action.payload};

		case types.SET_PATIENT_RECORD:
			return {...state, [action.payload._id]: action.payload};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/patient_records.js